import { render, staticRenderFns } from "./SmBtnToggle.vue?vue&type=template&id=28a0a137&scoped=true&"
import script from "./SmBtnToggle.vue?vue&type=script&lang=ts&"
export * from "./SmBtnToggle.vue?vue&type=script&lang=ts&"
import style0 from "./SmBtnToggle.vue?vue&type=style&index=0&id=28a0a137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0a137",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VBtnToggle,VDivider})
